<div class="dto-header flex align-items-center mb-2">
  <i class="mr-2 fa fa-folder"></i>

  <span class="text-xl font-medium">Objekte</span>

  <!-- Favoriten-Button -->
  <div
    jmlFavoriteButton
    [favoriteId]="'objects'"
    [favoriteName]="'Objekte'"
    [favoriteIcon]="'fa fa-folder'"
    [favoriteRoute]="'/configuration/dto-entities'"
  ></div>
</div>

<ng-container *ngIf="!isDetailView; else detailView">
  <p-dropdown
    [options]="dtoConfigs"
    placeholder="Konfiguration"
    (onChange)="selectedConfigChanged($event)"
    [(ngModel)]="currentConfig"
  ></p-dropdown>

  <div class="pt-3">
    <jml-lib-dynamic-table *ngIf="data" [tableData]="data" [preselectionId]="entityId$ | async"></jml-lib-dynamic-table>
  </div>
</ng-container>

<ng-template #detailView>
  <jml-lib-entity-view [configName]="entityType$ | async" [entryId]="entityId$ | async"></jml-lib-entity-view>
</ng-template>
